module.exports = __webpack_public_path__ + "static/media/m.14753987.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/m.mp3
// module id = 102
// module chunks = 0